import { AppDrawer } from '@components'
import type { ParentProps } from 'solid-js'
import { useService } from 'solid-services'
import Create from './Create'
import { useCreate } from './Create/state'
import List from './List'
import singleRoute from './Single'

function Container(props: ParentProps) {
	const { isCreateOpen, setIsCreateOpen, isEditing } = useService(useCreate)()
	return (
		<>
			{props.children}

			<AppDrawer
				open={isCreateOpen()}
				onOpenChange={({ open }) => setIsCreateOpen(open)}
				maxWidth="750px"
				title={isEditing() ? 'Edit Setup' : 'Create Setup'}
			>
				<Create />
			</AppDrawer>
		</>
	)
}

const routes = [
	{
		path: '/setups',
		component: Container,
		children: [
			{
				path: '/',
				component: List,
			},
			singleRoute,
		],
	},
]

export default routes
